import { useMemo } from 'react';
import { PAYMENT_MODE_OPTIONS } from '../constants';

export const useTransactionsFormFields = (patientId?: string | number) => {
  return useMemo(
    () => [
      {
        name: 'invoice_id',
        label: 'Invoice ID',
        type: 'resourceSelect',
        required: false,
        placeholder: 'Search and select invoice',
        layout: { span: 12 },
        searchSelectProps: {
          resource: 'clinic-invoices',
          optionValue: 'id',
          searchFields: ['id'],
          searchDebounceMs: 300,
          filters: patientId ? [
            {
              field: 'patient_id',
              operator: 'eq',
              value: patientId,
            },
          ] : [],
          optionRender: (invoice: any) => (
            `Invoice #${invoice.id} - ₹${Number(invoice.due_amount || 0).toFixed(2)} due`
          ),
          allowClear: true,
        },
      },
      {
        name: 'payment_mode',
        label: 'Payment Mode',
        type: 'select',
        required: true,
        options: PAYMENT_MODE_OPTIONS,
        placeholder: 'Select payment mode',
        layout: { span: 12 },
      },
      {
        name: 'amount',
        label: 'Amount',
        type: 'number',
        required: true,
        placeholder: 'Enter amount',
        layout: { span: 12 },
        min: 0,
        step: 0.01,
        format: 'currency',
      },
    ],
    [patientId]
  );
};
